import ContentLoader from 'react-content-loader'

export const Skeleton: typeof ContentLoader = (props) => {
	return (
		<div
			className='flex [&_svg]:shrink-0'
			style={{ width: props.width ? `${props.width}px` : '100%' }}
		>
			<ContentLoader
				backgroundColor='var(--color-neutral-100)'
				foregroundColor='var(--color-neutral-200)'
				height='100%'
				width='100%'
				{...props}
			>
				<rect height='100%' rx='4' ry='4' width='100%' x='0' y='0' />
			</ContentLoader>
		</div>
	)
}

Skeleton.displayName = 'Skeleton'
